/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOrderStop.ts                     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/order-stop";

export class AutogenModelOrderStop<RowType extends ModelRow> extends Endpoint<RowType, RowOrderStopFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOrderStop extends ModelRow<RowOrderStopFields> {
	constructor(values?: Partial<RowOrderStopFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOrderStopFields {
	actual_arrival: Date;
	actual_departure: Date;
	address: string;
	address2: string;
	appointment_status_id: string;
	appt_contact_name: string;
	appt_required: string;
	authorized: string;
	average_broker_rating: number;
	booking_no: string;
	br_details_link: string;
	br_status_link: string;
	br_track_interval: number;
	br_track_status: string;
	br_track_status_desc: string;
	br_track_vehicle_id: string;
	br_tracking_id: string;
	br_vendor: string;
	broker_avail_tract: string;
	brokerage: string;
	brokerage_status: string;
	carrier_contact: string;
	carrier_email: string;
	carrier_empty_from_city_id: number;
	carrier_fuel_pay_rate_id: number;
	carrier_lane_rate_id: string;
	carrier_override_carrier: string;
	carrier_override_user: string;
	carrier_phone: string;
	carrier_rate_id: number;
	carrier_tractor: string;
	carrier_trailer: string;
	carrier_trailer_type: string;
	cases: number;
	chassis: string;
	checkcall_sched_id: string;
	city_id: number;
	city_name: string;
	company_id: string;
	confirmed: string;
	contact_email: string;
	contact_name: string;
	container: string;
	container_returned: string;
	container_status: string;
	controlling_carrier_code: string;
	dedicated_order_id: string;
	dest_stop_id: string;
	digital_booking: string;
	dispatcher_user_id: string;
	dist_from_prev: number;
	dist_from_prev_um: string;
	driver_load_unload: string;
	edi_code: string;
	edi_loc_code: string;
	eform_rate_confirmation: string;
	empty2next_order: string;
	equipment_group_id: string;
	est_tolls: number;
	est_tolls_c: string;
	est_tolls_d: Date;
	est_tolls_n: number;
	est_tolls_r: number;
	eta: Date;
	eta_distance: number;
	eta_late: string;
	eta_oor: string;
	exclude_movement: string;
	fleet_manager: string;
	freight_matching_override: string;
	fuel_distance: number;
	fuel_distance_um: string;
	fuel_tax_exempt: string;
	google_place_id: string;
	grouped_id: number;
	hub: number;
	hubtran_approved_inv_date: Date;
	hubtran_ok2pay_date: Date;
	ic_company_to: string;
	ic_order_to: string;
	ic_stop_id: string;
	id: string;
	inbound_status: string;
	integrated_carrier_search: string;
	invoice_recv_date: Date;
	is_container: string;
	is_dray: string;
	is_intercompany: string;
	is_local_mile: string;
	late_eta_colorcode: string;
	late_route_status: string;
	latitude: number;
	linked_id: number;
	linked_sequence: number;
	load_booking_eligible: string;
	load_booking_source: string;
	loaded: string;
	location_id: string;
	location_name: string;
	locked_user_id: string;
	longitude: number;
	ltl: string;
	ltl_staging_wrs_uid: number;
	macropoint_status: string;
	manifest_empty_distance: number;
	manifest_estimated_arrival: Date;
	manifest_estimated_depart: Date;
	manifest_fgp_uid: number;
	manifest_id: string;
	manifest_loaded_distance: number;
	manifest_reg_uid: number;
	manifest_spots_capacity: number;
	manifest_spots_consumed: number;
	manifest_weight_capacity: number;
	manifest_weight_consumed: number;
	max_buy: number;
	max_buy_c: string;
	max_buy_d: Date;
	max_buy_n: number;
	max_buy_r: number;
	max_pay_method: string;
	max_pay_units: number;
	missed_call_sent: string;
	move_dist_from_preassign: number;
	move_dist_from_preassign_um: string;
	move_dist_from_previous: number;
	move_dist_from_previous_um: string;
	move_distance: number;
	move_distance_um: string;
	movement_id: string;
	movement_sequence: number;
	movement_type: string;
	must_respond_by: Date;
	next_sched_call: Date;
	operational_status: string;
	operations_user: string;
	order_id: string;
	order_sequence: number;
	orig_sched_early: Date;
	orig_sched_late: Date;
	origin_stop_id: string;
	override_crny_type: string;
	override_driver2_id: number;
	override_driver2_nm: string;
	override_driver_id: number;
	override_driver_nm: string;
	override_drvr2_cell: string;
	override_drvr2_email: string;
	override_drvr_cell: string;
	override_drvr_email: string;
	override_max_pay: number;
	override_max_pay_c: string;
	override_max_pay_d: Date;
	override_max_pay_n: number;
	override_max_pay_r: number;
	override_pay_amt: number;
	override_pay_amt_c: string;
	override_pay_amt_d: Date;
	override_pay_amt_n: number;
	override_pay_amt_r: number;
	override_pay_rate: number;
	override_paye_rate: number;
	override_payee_id: string;
	override_targetpay: number;
	override_targetpay_c: string;
	override_targetpay_d: Date;
	override_targetpay_n: number;
	override_targetpay_r: number;
	override_type: string;
	override_unit_desc: string;
	override_units: number;
	pallets_dropped: number;
	pallets_picked_up: number;
	pay_distance: number;
	pay_distance_um: string;
	payment_code_reviewed: string;
	pending_carrier_name: string;
	pending_carrier_nbr: string;
	pending_carrier_type: string;
	pending_payee_id: string;
	phone: string;
	placard_required: string;
	planned_arrival_time: Date;
	ponum: string;
	preassign_sequence: number;
	prior_uncleared_stops: string;
	priority: string;
	pro_nbr: string;
	projected_arrival: Date;
	pu_override_arrive_early: Date;
	pu_override_arrive_late: Date;
	rate_alert_basis: string;
	rate_alert_date: Date;
	rate_alert_days: number;
	rate_alert_hours: number;
	rate_alert_minutes: number;
	rate_confirm_template: number;
	rate_confirmation_sent_date: Date;
	rate_confirmation_status: string;
	rate_dist_from_previous: number;
	rate_dist_from_previous_um: string;
	rate_expiration_basis: string;
	rate_expiration_date: Date;
	rate_expiration_days: number;
	rate_expiration_hours: number;
	rate_expiration_minutes: number;
	rdy_pickup_date: Date;
	recurring_movement_id: string;
	reference_numbers: string;
	refno: string;
	reminder_sent: string;
	requested_service: string;
	require_tracking: string;
	required_vendor: string;
	reserved: string;
	return_date: Date;
	sched_arrive_early: Date;
	sched_arrive_late: Date;
	seal: string;
	seg_alloc_code: string;
	service_date: Date;
	shipper_email: string;
	shipper_notify_frequency: string;
	showas_address: string;
	showas_address2: string;
	showas_city_id: number;
	showas_city_name: string;
	showas_location_id: string;
	showas_location_name: string;
	showas_state: string;
	showas_zip_code: string;
	shpmt_ident_type: string;
	shpmt_ident_value: string;
	signed_for_name: string;
	ss_location_id: string;
	state: string;
	status: string;
	stop_notes: string;
	stop_type: string;
	target_extra_stop_pay: number;
	target_extra_stop_pay_c: string;
	target_extra_stop_pay_d: Date;
	target_extra_stop_pay_n: number;
	target_extra_stop_pay_r: number;
	target_fuel_surcharge_pay: string;
	target_pay: number;
	target_pay_c: string;
	target_pay_d: Date;
	target_pay_method: string;
	target_pay_n: number;
	target_pay_r: number;
	target_pay_units: number;
	target_rate_data: string;
	target_rate_id: number;
	time_to_send_msg: Date;
	track_start_date: Date;
	tracking_duration_ext: number;
	tracking_notify_email: string;
	tracking_request_status: string;
	trailer_rent_pct: number;
	trimble_place_id: string;
	trip_lease: string;
	trip_mgt_recalc_datetime: Date;
	trip_mgt_tracking_id: string;
	triumphpay_exclude: string;
	trp_uid: number;
	ts_borrowing_company: string;
	ts_commodity: string;
	ts_movement_id: string;
	txl_uid: number;
	unlock_time: Date;
	volume: number;
	volume_um: string;
	waterfall_flood_time: Date;
	waterfall_in_progress: string;
	weight: number;
	weight_um: string;
	xfer2settle_date: Date;
	xferred2fueltax: string;
	xferred2fueltaxdt: Date;
	xmit_accepted: string;
	xmitted2driver: Date;
	zip_code: string;
	zmit_trip: string;
	zone_id: string;
}

